<template>
  <div class="job-position-card">
    <div class="job-position-card__content">
      <p class="job-position-card__name">{{ name }}</p>
      <div class="job-position-card__properties">
        <p
          class="job-position-card-property"
          v-for="property in properties"
          :key="property.icon"
        >
          <i
            class="fa-solid job-position-card-property__icon"
            :class="property.icon"
          />
          <span class="job-position-card-property__value">{{
            property.value
          }}</span>
        </p>
      </div>
    </div>
    <Button
      class="job-position-card__details-button"
      size="sm"
      type="primary"
      :href="`/careers/${id}`"
    >
      View Details
    </Button>
  </div>
</template>

<script setup lang="ts">
  import Button from "../buttons/Button.vue";

  export interface JobPositionCardProps {
    id: number;
    name: string;
    location?: string;
    type?: string;
    department?: string;
  }

  const props = defineProps<JobPositionCardProps>();

  const properties = computed(() => [
    {
      icon: "fa-pen",
      value: props.department,
    },
    {
      icon: "fa-location-dot",
      value: props.location,
    },
    {
      icon: "fa-clock",
      value: props.type,
    },
  ]);
</script>

<style lang="scss">
  .job-position-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    padding: 32px;

    border: 2px solid color-mix(in srgb, #212529, transparent 90%);
    border-radius: 16px;
    //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.025);

    @media (max-width: $sm) {
      align-items: flex-start;
      flex-direction: column;
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    &__name {
      color: #212529;
      font-family: var(--font-family-main);
      font-size: 32px;
      line-height: 1.15;
      letter-spacing: 0.5px;
      font-weight: 700;
      text-transform: capitalize;

      //max-width: 400px;

      @media (max-width: $md) {
        font-size: 28px;
      }
    }

    &__department {
      font-size: 14px;
    }

    &__properties {
      display: flex;
      align-items: center;
      column-gap: 16px;
      row-gap: 16px;

      @media (max-width: $sm) {
        align-items: flex-start;
        flex-direction: column;
      }
    }
  }

  .job-position-card-property {
    //display: flex;
    //gap: 8px;
    white-space: nowrap;

    &__icon {
      margin-right: 6px;

      color: #212529;
      font-family: "Font Awesome 6 Free", sans-serif;
      font-size: 14px;
      font-weight: 900;
      white-space: nowrap;
    }

    &__value {
      color: #212529;
      font-family: var(--font-family-main);
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
    }
  }
</style>
